import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'

const ConsultaJefes = () => {
    return (
            <>
                {sessionStorage.login
                ?
                    <div className="listado" id="menu">
                        <h2 className='tituloAccion'>Consultas</h2>
                        <TableContainer>
                            <Table sx={{minWidth: 500}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><a href="./Consulta-Calificaciones">Calificaciones</a></TableCell>
                                        <TableCell><a href="./Consultas-SolicitudesFuncionarios">Solicitudes Funcionarios</a></TableCell>
                                    </TableRow>
                                    {sessionStorage.lugarCentral === '20'
                                    ?
                                        <TableRow>
                                            <TableCell><a href="./Consulta-DatosFuncionarios">Datos Funcionarios</a></TableCell>
                                            <TableCell><a href="./Consultas-MovimientosFuncionarios">Movimientos Funcionarios</a></TableCell>
                                        </TableRow>
                                    :
                                        null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                :
                    <Redirect to='/login'/>
                }
            </>
        )
}

export default ConsultaJefes